module.exports = __webpack_public_path__ + "img/favourite-heart.8f9d2180.svg";